import { render, staticRenderFns } from "./OffsetX.vue?vue&type=template&id=fda3293c&"
import script from "./OffsetX.vue?vue&type=script&lang=js&"
export * from "./OffsetX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports